/* A page shown inside another page (the customer's chart beside a session, a payment inside a sheet) is the content only: no app shell, menu or footer of its own,
   so there is never an app inside an app. The marker is body.rfhq-framed; the rules are in rfhq_templates.css. */
try {
	if (window.self !== window.top) document.body.classList.add("rfhq-framed");
} catch (e) {
	document.body.classList.add("rfhq-framed"); // (a frame we may not look out of is a frame all the same)
}
